import { useEffect } from "react";
import axiosInstance from "interceptor/axiosInstance";
import { Redirect } from "types/cms/Redirects";

const useRedirect = () => {
    useEffect(() => {
        axiosInstance.get(`${process.env.REACT_APP_CMS_API_URL}/api/redirects`)
            .then((response: any) => {
                const redirect: Redirect = response.data.docs[0];
                const redirectType = redirect.to.type;
                const isRedirectPage = redirectType === 'reference';
                const isRedirectCustom = redirectType === 'custom';

                if (redirect.from === window.location.href && (isRedirectPage || isRedirectCustom)) {
                    console.log('redirecting ....');
                    const newUrl = isRedirectPage ? redirect.to.reference?.value.slug : redirect.to.url ?? '';
                    window.location.href = newUrl;
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }, []);
};

export default useRedirect;